import { render, staticRenderFns } from "./SendClaimDialog.vue?vue&type=template&id=7e7cd5b0&scoped=true&lang=pug&"
import script from "./SendClaimDialog.vue?vue&type=script&lang=js&"
export * from "./SendClaimDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendClaimDialog.vue?vue&type=style&index=0&id=7e7cd5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7cd5b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
